import type { HomeView } from '../../store/map.store';

/**
 * The company's start view as `/api/account` gives it (softRole.mapViewConfiguration, the shape the old
 * backend had): `{ zoomLevel, mapViewCenter: { lat, lon } }`, degrees in WGS 84. Anything missing or out of
 * range is ignored, so a wrong entry never throws the map into the ocean.
 */
export function companyHomeView(user: unknown): HomeView | null {
  const role = (user as { softRole?: { mapViewConfiguration?: unknown } } | null)?.softRole;
  const conf = role?.mapViewConfiguration as
    | { zoomLevel?: unknown; mapViewCenter?: { lat?: unknown; lon?: unknown } }
    | null
    | undefined;
  const lat = Number(conf?.mapViewCenter?.lat);
  const lon = Number(conf?.mapViewCenter?.lon);
  if (!conf || !Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  if (Math.abs(lat) > 90 || Math.abs(lon) > 180) return null;
  const z = Number(conf.zoomLevel);
  const zoom = Number.isFinite(z) ? Math.min(20, Math.max(1, z)) : 11;
  return { center: [lon, lat], zoom };
}

/** The company's logo address, as `/api/account` gives it (softRole.logoUrl); null when it has none. */
export function companyLogoUrl(user: unknown): string | null {
  const url = (user as { softRole?: { logoUrl?: unknown } } | null)?.softRole?.logoUrl;
  return typeof url === 'string' && url.trim() ? url.trim() : null;
}
